import React, {useState, useEffect } from "react";
import {useParams} from "react-router-dom"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Link} from "react-router-dom";
import "./page_3_stallion_detail.css";

function Page_3_stallion_detail(){
    
    const { id } = useParams();
    const [data, setData] = useState(null);
    useEffect(()=>{
        fetch("/data.json").then(response => response.json()).then(data=> setData(data)).catch(error => console.error("cannot load data in file data.json : ",error));
    } ,[]);
    if(!data){return(<div>Is loading...</div>)};

    const champion= data.items.filter((el) => el.id === id)[0];

    //let fs = require('fs');
    //let files = fs.readdirSync('/assets/photos/'); 

    return(
        

        //import ownerPicture_2 from "../../../data/appData/appImages/owner/owner2.jpg" ;
        <div className="page4_stallions_content">
            <div className="float-start w-100 text-center mt-3 fw-bold fs-5 mb-3"><Link className=" text-secondary" to="/page3_stallions">Nos Stallions</Link> <span className="text-secondary">/ {champion.name}</span></div>
            
            
                <Container className="page4_stallion_container ">
                          

                    <Row className="row_container">
                        <Col xs={0} sm={6}  md={6} lg={6} xsHidden smHidden className="page4_stallion_col2">
                            <StallionInfoDetail  champion={champion} ></StallionInfoDetail>    
                        </Col>
                        <Col xs={12} sm={6}  md={6} lg={6} className="page4_stallion_col1">
                            <img  className="championPicture" onContextMenu={(e)=> e.preventDefault()} src={"/data/appData/appImages/stallions_picture/" + champion.id+".jpg"} alt=""  />
                        </Col>
                        
                    </Row>
                               

                </Container>
                
                <div className="stallions_gallery_container">

                    {    /*
                         files.map(file, index){
                            
                         }*/
                    }

                </div>

        </div>
        

    )

    function StallionInfoDetail(props){
        let champion = props.champion ;
        return(
            <div>
                <div className="divMarg d-none d-lg-block d-md-block d-sm-block d-xs-none "></div>
                <div className="page_3_stallion_para_div">
                    
                    <p className="page_3_stallion_detail_para">
                        <span className="fs-5 fw-bold">{  champion.name}</span><br></br>
                        { champion.borne_date }<br></br>
                        { champion.isStraightEgyptian && <span>Staight Egyptian<br></br></span>}
                        { champion.father} x { champion.mother }<br/><br/>
                        Breeding Fee: {champion.breeding_price}€

                    </p>  
                    
                </div>   
            </div> 
        )
    }

}

export default Page_3_stallion_detail